export function isElectronShell(): boolean {
  return typeof window !== "undefined" && Boolean(window.electronAPI);
}
